import { BaseComponent } from '../../components/base-component'
import { CartDrawer } from './cart-drawer'
import { replaceNodeChildren } from '../../utils/dom'
import { CartDrawerRelatedProducts } from '.'
import { $el, $list, $elParent } from 'src/scripts/utils/utils'
import { CarouselComponent } from 'src/scripts/components/carousel'

const RELATED_PRODUCTS_SELECTOR = '[data-cart-drawer-related-products]'
const CART_DRAWER_SELECTOR = 'cart-drawer'
const CART_DRAWER_RELATED_PRODUCTS_SELECTOR =
  'cart-drawer-related-products-block'
const CAROUSEL_SELECTOR = 'carousel-component'

export class CartDrawerRelatedProductsBlock extends BaseComponent {
  mountComponent(): void {
    const cartDrawer: CartDrawer = $elParent(CART_DRAWER_SELECTOR, this)
    cartDrawer?.on('update-nodes', this.handleCartDrawerUpdate)
  }

  unmountComponent(): void {
    const cartDrawer: CartDrawer = $elParent(CART_DRAWER_SELECTOR, this)
    cartDrawer?.off('update-nodes', this.handleCartDrawerUpdate)
  }

  handleCartDrawerUpdate = ({ node }): void => {
    const relatedProducts: CartDrawerRelatedProducts = $el(
      RELATED_PRODUCTS_SELECTOR,
      this,
    )

    if (!relatedProducts) {
      return
    }

    const newRelatedProducts = $el(
      `${CART_DRAWER_RELATED_PRODUCTS_SELECTOR}[block-id="${this.getAttribute(
        'block-id',
      )}"] [data-cart-drawer-related-products]`,
      node,
    )

    if (!newRelatedProducts) {
      return
    }

    const isAuto = this.hasAttribute('is-auto-recommendations')
    if (isAuto) {
      const newUrl = newRelatedProducts.getAttribute('data-url')

      relatedProducts.setAttribute('data-url', newUrl)

      if (newUrl) {
        relatedProducts.loadProducts()
      } else {
        relatedProducts.erase()
        this.checkHasAsideProducts()
        this.updateVisibility()
      }
    } else {
      replaceNodeChildren(relatedProducts, newRelatedProducts)
      this.checkHasAsideProducts()
      this.updateVisibility()
    }

    this.reInitCarousel()
  }

  checkHasAsideProducts(): void {
    const isAsideProducts = this.hasAttribute('is-aside-related-products')

    if (isAsideProducts) {
      const products = $list(
        '[is-aside-related-products] vertical-product-card, [is-aside-related-products] horizontal-product-card',
      )
      const cartDrawer = $el('cart-drawer')
      const hasAsideProducts = products?.length > 0

      if (cartDrawer) {
        cartDrawer.toggleAttribute('has-aside-products', hasAsideProducts)
      }
    }
  }

  updateVisibility = () => {
    const isAsideProducts = this.hasAttribute('is-aside-related-products')

    if (!isAsideProducts) {
      const cartDrawer = $el('cart-drawer')
      const cartDrawerItems = Boolean($el('cart-item', cartDrawer))

      cartDrawer.toggleAttribute('empty-cart', !cartDrawerItems)
    }
  }

  reInitCarousel = () => {
    const carousel: CarouselComponent = $el(CAROUSEL_SELECTOR, this)

    if (carousel && carousel.withAutoplay) {
      carousel.setCarousel()
      carousel.setAutoplay()
    }
  }
}
